const BEARER_TOKEN_KEY = 'authBearerToken';
const REFRESH_TOKEN_KEY = 'authRefreshToken';
const BEARER_TOKEN_EXPIRATION_KEY = 'authBearerTokenExpiration';

export default {
  BEARER_TOKEN_KEY,
  BEARER_TOKEN_EXPIRATION_KEY,
  REFRESH_TOKEN_KEY,
};
